// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22H2V9H22V22ZM16.5 17L12.0001 12.5L7.5 17H16.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2V7H2V2H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-expand-up-filled')
export default class ExpandUpFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'expand-up-filled',
    }
  }
}
